<template>
  <v-card flat>
    <v-container>
    <v-form ref="form" v-model="form.valid">
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">食品名</v-flex>
        <v-flex xs12>
          <v-text-field 
            v-model="form.name"
            :rules="[rules.required, rules.max50]"
            placeholder=" 食品の名称を入力ください" style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">カテゴリ選択</v-flex>
        <v-flex xs12>
          <v-select
           v-model="form.category"
           :rules="[rules.required]"
           :items="configCategory"
           item-text="value" item-value="key" style="padding-top:0;"
           placeholder=" 食品のカテゴリを選択してください"></v-select>
        </v-flex>
      </v-layout>
      <!-- 画像エリア-->
      <v-layout row wrap class="formBlock">
        <input type="file" style="display: none;" ref="image" v-on:change="onFileChange" mulitple="multiple">
        <v-flex md2 xs12 class="formElementLabel">画像の登録</v-flex>
        <v-layout v-if="imageURI.length>0" row wrap>
          <v-flex xs4 md4 v-for="(image, id) in imageURI" :key=id>
            <p style="text-align:right;position:absolute;width:30%;max-width:150px;">
              <v-btn fab small color="white" @click="clearImage(id)">
                <v-icon>clear</v-icon>
              </v-btn>
            </p>
            <img :src="image" style="max-width:90%;max-heght:300px;">
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <v-btn @click="pickImage()" flat outline block round color="primary">
            <v-icon>add photo</v-icon>画像を追加する
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- /画像エリア-->
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">説明文</v-flex>
        <v-flex xs12>
          <v-textarea
            v-model="form.description"
            :rules="[rules.required, rules.max500]"
            placeholder=" 商品情報を入力してください" style="padding-top:0;" rows="10"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs4 md2><v-subheader>メーカー</v-subheader></v-flex>
        <v-flex xs8 md10>
          <v-text-field 
            v-model="form.maker"
            :rules="[rules.max50]"
            placeholder="例：日清食品" style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs4 md2><v-subheader>シリーズ名</v-subheader></v-flex>
        <v-flex xs8 md10>
          <v-text-field 
            v-model="form.brand"
            :rules="[rules.max50]"
            placeholder="例：カップヌードル" style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs4 md2><v-subheader>販売価格</v-subheader></v-flex>
        <v-flex xs8 md10>
          <v-text-field 
            v-model="form.makerPrice"
            :rules="[rules.max50]"
            placeholder="例：300" style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs4 md2><v-subheader>カロリー</v-subheader></v-flex>
        <v-flex xs8 md10>
          <v-text-field 
            v-model="form.kcal"
            :rules="[rules.max50]"
            placeholder="100" style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs4 md2><v-subheader>内容量</v-subheader></v-flex>
        <v-flex xs8 md10>
          <v-text-field 
            v-model="form.content"
            :rules="[rules.max50]"
            placeholder="100" style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs4 md2><v-subheader>発売日</v-subheader></v-flex>
        <v-flex md5 xs6>
          <v-menu
            v-model="dateForm"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="form.releaseDate"
                placeholder="yyyy-mm-dd"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker no-title v-model="form.releaseDate" @input="dateForm = false"></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs4 md2><v-subheader>Janコード</v-subheader></v-flex>
        <v-flex xs8 md10>
          <v-text-field 
            v-model="form.jan"
            :rules="[rules.max50]"
            placeholder="49xxxxxxxxxxxxxx" style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">タグの追加</v-flex>
        <v-flex xs12>
          <vue-tags-input element-id="tags"
            v-model="form.tags"
            placeholder="タグを入力"
            :typeahead="true"
            :existing-tags="configTag"
          ></vue-tags-input>
        </v-flex>
        <v-flex xs12 style="text-align:left;padding:5px 0;overflow-x: auto;white-space:nowrap;">
          <v-chip label dark color="grey darken-2">人気</v-chip>
          <v-chip
            @click="addTag(tag)"
            v-for="(tag, id) in displayTag" color="red" outline small :key=id>
              {{tag.value}}
          </v-chip>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">原材料</v-flex>
        <v-flex xs12>
          <v-textarea
            v-model="form.materials"
            :rules="[rules.max500]"
            placeholder=" 原材料を入力してください" style="padding-top:0;" rows="6"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs5 md3><v-subheader>メーカーサイト</v-subheader></v-flex>
        <v-flex xs7 md9>
          <v-text-field 
            v-model="form.makerURL"
            :rules="[rules.max500]"
            placeholder="https://www.karai.com" style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs4 md3><v-subheader>検索テキスト</v-subheader></v-flex>
        <v-flex xs8 md9>
          <v-text-field 
            v-model="form.searchText"
            :rules="[rules.max50]"
            placeholder="スペース区切りで検索キーワードを入力してください" style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs4 md3><v-subheader>SNS上の反応・感想</v-subheader></v-flex>
        <v-flex xs8 md9>
          <v-text-field v-for="(sns, id) in form.snsUrls" :key=id
           v-model="form.snsUrls[id]"
           :rules="[rules.max500]"
           placeholder="Youtube、TwitterのURLを記入ください"
          >
          </v-text-field>
          <div style="text-align:left;">
            <v-btn flat @click="form.snsUrls.push('')"><v-icon>add</v-icon>&nbsp;SNSの反応を追加する</v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="formBlock">
        <v-flex xs12>
          <v-btn @click="sendForm()" block dark large color="primary">
            <div v-if="isLoading">
              <v-progress-circular
                indeterminate
                color="white"
              ></v-progress-circular>
            </div>
            <span v-else>登録する</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
    </v-container>
  </v-card>
</template>

<script>
import { db, storageRef } from '@/main'
import imageResize from '@/assets/js/imageResize.js'
import VueTagsInput from '@voerro/vue-tagsinput'
var fileExtensions = ['jpg', 'jpeg', 'png', 'bmp', 'gif']
const maxSize = 700
// @ is an alias to /src
export default {
  name: 'FoodForm',
  data () {
    return {
      isLoading: false,
      id: undefined,
      dateForm: false,
      form: {
        name: '',
        category: '',
        categoryname:'',
        tags: [],
        description: '',
        maker: '',
        brand: '',
        makerPrice: '',
        kcal: '',
        content: '',
        releaseDate: '',
        jan: '',
        materials: '',
        makerURL: '',
        searchText: '',
        valid: false,
        snsUrls: [],
        famousScore: 0,
        user: undefined
      },
      imageData: [],
      imageURI: [],
      imageUploadedCounter: 0,
      rules: {
        required: v => !!v || '必須項目です。',
        max50: v => {
          return v.length <= 50 || '入力できるのは50文字までです。'
        },
        max500: v => {
          return v.length <= 500 || '入力できるのは500文字までです。'
        }
      }
    }
  },
  created () {
    // this.getCategory()
    if (this.$route.name === 'updateFood') {
      // 更新
      this.getData()
    }
  },
  computed: {
    displayTag () {
      let tags = []
      this.configTag.forEach(tag => {
        let flag = false
        for (let i = 0; i < this.form.tags.length; i++) {
          if (this.form.tags[i].key === tag.key) {
            flag = true
            break
          }
        }
        if (!flag) {
          tags.push(tag)
        }
      })
      return tags
    },
    user () {
      return this.$store.state.user
    },
    configCategory () {
      return this.$store.state.config.category
    },
    configTag () {
      return this.$store.state.config.tag
    }
  },
  methods: {
    async sendForm () {
      this.imageUploadedCounter = 0
      if (this.isLoading) return

      this.$refs.form.validate()
      if (!this.form.valid) {
        let obj = {
          group: 'messageBottom',
          type: 'warning',
          title: '入力エラー',
          text: '各項目のエラーメッセージを確認して修正をお願いします。'
        }
        this.$emit('onMessage', obj)
        return
      }
      let sendData = this.makeFormObj()
      this.isLoading = true
      let result = {}
      if (this.$route.name === 'updateFood') {
        // アップデート
        result = await db.collection('food').doc(this.id).set(sendData, {merge: true})
      } else {
        // 新規追加
        result = await db.collection('food').add(sendData)
        this.id = result.id
      }

      let imageCounter = this.UnUploadImageCount(this.imageData)
      if (imageCounter > 0) {
        // var storageRef = storage.ref()
        for (let i = 0; i < this.imageData.length; i++) {
          if (this.imageData[i] !== 'saved') {
            let imageRef = storageRef.child(`food/${this.id}/${sendData.images[i]}`)
            imageRef.put(this.imageData[i]).then(() => {
              this.imageUploadedCounter++
              if (this.imageUploadedCounter === imageCounter) {
                //完了
                this.sendFin()
              }
            })
          }
        }
      } else {
        // 完了
        this.sendFin()
      }
    },
    UnUploadImageCount (imageList) {
      let counter = 0
      imageList.forEach(i => {
        if (i !== 'saved') {
          counter++
        }
      })
      return counter
    },
    sendFin () {
      this.isLoading = false
      let obj = {
        group: 'messageBottom',
        type: 'success',
        title: 'Thank you !!',
        text: '登録が完了しました！'
      }
      this.$emit('onMessage', obj)
      this.$router.push({name: 'searchFoodDetail', params: {id: this.id }})
    },
    makeFormObj () {
      let timestamp = new Date()
      // 必須情報の設定
      let obj = {
        name: this.form.name,
        category: this.form.category,
        categoryname: this.$store.getters.getCategoryNameByKey(this.form.category),
        tags: this.getTagListObj(),
        _tags: this.getTagAlgolia(),
        description: this.form.description,
        timestamp: timestamp,
        famousScore: this.form.famousScore
      }

      if (this.$route.name === 'updateFood') {
        // アップデート
      } else {
        // 新規追加
        // 件数の初期値を設定しておく
        obj.postCount = 0
        obj.tabetaiCount = 0
      }

      // 任意情報の追加
      // 今後もカラム追加の可能性があるので未設定はundefined
      if (this.form.maker !== '') obj.maker = this.form.maker
      if (this.form.brand !== '') obj.brand = this.form.brand
      if (this.form.makerPrice !== '') obj.makerPrice = Number(this.form.makerPrice)
      if (this.form.kcal !== '') obj.kcal = Number(this.form.kcal)
      if (this.form.content !== '') obj.content = this.form.content
      if (this.form.releaseDate !== '') obj.releaseDate = this.form.releaseDate
      if (this.form.jan !== '') obj.jan = this.form.jan
      if (this.form.materials !== '') obj.materials = this.form.materials
      if (this.form.makerURL !== '') obj.makerURL = this.form.makerURL
      if (this.form.searchText !== '') obj.searchText = this.form.searchText
      if (this.form.snsUrls) {
        obj.snsUrls = []
        this.form.snsUrls.forEach(url => {
          if (url !== '') {
            obj.snsUrls.push(url)
          }
        })
      } 
      if (this.form.user) {
        obj.user = this.form.user
      } else {
        let user = {
          uid: this.user.uid,
          displayName: this.user.displayName,
          imageurl: this.user.imageurl
        }
        obj.user = user
      } 
      let images = []
      for (let i = 0; i < this.imageData.length; i++) {
        images.push(`${i}.png`)
      }
      obj.images = images

      return obj
    },
    getTagListObj () {
      let tagObj = {}
      this.form.tags.forEach((tag) => {
        tagObj[tag.value] = true
      })
      return tagObj
    },
    getTagAlgolia () {
      let tags = []
      this.form.tags.forEach((tag) => {
        tags.push(tag.value)
      })
      return tags
    },
    addTag (tag) {
      this.form.tags.push(tag)
    },
    pickImage () {
      if (this.imageData.length >= 3) {
        let obj = {
          group: 'messageBottom',
          type: 'warning',
          title: '入力エラー',
          text: 'アップロードできる画像は3枚までです。'
        }
        this.$emit('onMessage', obj)
        return
      }
      this.$refs.image.click()
    },
    async onFileChange (e) {
      let files = e.target.files || e.dataTransfer.files

      var myFileType = files[0].type
      var fileTypeCheck = false
      for (var i = 0; i < fileExtensions.length; i++) {
        var fileExtension = fileExtensions[i]
        if (myFileType.indexOf(fileExtension) > -1) {
          fileTypeCheck = true
          break
        }
      }
      if (!fileTypeCheck) {
        let message = {
          group: 'messageBottom',
          type: 'warning',
          title: '入力エラー',
          text: 'アップロードできるのは画像のみです。'
        }
        this.$emit('onMessage', message)
        return
      }
      const src = await imageResize.pFileReader(files[0])
      this.imageURI.push(src)
      const img = await imageResize.pImage(src)
      const blob = await imageResize.resizeImage(img, maxSize, 'image/png')
      this.imageData.push(blob)
    },
    clearImage (id) {
      if (this.imageData[id] === 'saved') {
        storageRef.child(`food/${this.id}/${this.form.images[id]}`).delete()
          .then(() => {
            let message = {
              group: 'messageArea',
              type: 'success',
              title: '画像を削除しました'
            }
            this.$emit('onMessage', message)
          })
          .catch(error => {
            console.log(error)
          })
        this.form.images.splice(id, 1)
      }
      this.imageURI.splice(id, 1)
      this.imageData.splice(id, 1)
    },
    getData () {
      // store経由でアップデートデータを取得
      this.id = this.$store.state.temp.id
      let foodData = this.$store.state.temp.foodData
      this.imageURI = this.$store.state.temp.images

      // 入力フォーム用のオブジェクトに加工
      this.form.category = foodData.category
      this.form.description = foodData.description
      this.form.name = foodData.name
      this.form.images = foodData.images
      this.form.timestamp = foodData.timestamp
      let tags = []
      for (var value in foodData.tags) {
        let tag = this.$store.getters.getTagByValue(value)
        let key = ''
        if (tag !== undefined) {
          key = tag.key
        }
        let obj = {
         key: key,
         value: value
        }
        tags.push(obj)
      }
      this.form.tags = tags
      for (let i = 0; i < this.form.images.length; i++) {
        this.imageData.push('saved')
      }

      if (foodData.maker) this.form.maker = foodData.maker
      if (foodData.brand) this.form.brand = foodData.brand
      if (foodData.makerPrice) this.form.makerPrice = String(foodData.makerPrice)
      if (foodData.kcal) this.form.kcal = String(foodData.kcal)
      if (foodData.content) this.form.content = foodData.content
      if (foodData.releaseDate) this.form.releaseDate = foodData.releaseDate
      if (foodData.jan) this.form.jan = foodData.jan
      if (foodData.materials) this.form.materials = foodData.materials
      if (foodData.makerURL) this.form.makerURL = foodData.makerURL
      if (foodData.searchText) this.form.searchText = foodData.searchText
      if (foodData.snsUrls) this.form.snsUrls = foodData.snsUrls
      if (foodData.famousScore) this.form.famousScore = foodData.famousScore
      if (foodData.user) this.form.user = foodData.user
    }
  },
  components: {
    VueTagsInput
  }
}
</script>

<style scoped>
.formBlock {
  margin-bottom:10px;
}
/* The input */
.formElementLabel {
  text-align: left;
  color:#888;
}
</style>

<style>
.tags-input {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.tags-input input {
    flex: 1;
    background: transparent;
    border: none;
}

.tags-input input:focus {
    outline: none;
}

.tags-input input[type="text"] {
    color: #495057;
}

.tags-input-wrapper-default {
    padding: 10px;
    background: #fff;
    border: 1px solid transparent;
    border-radius: .25rem;
    border-color: #dbdbdb;
}

/* The tag badges & the remove icon */
.tags-input span {
    margin-right: 0.3rem;
}

.tags-input-remove {
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    overflow: hidden;
}

.tags-input-remove:before, .tags-input-remove:after {
    content: '';
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    background: #5dc282;
    
    height: 2px;
    margin-top: -1px;
}

.tags-input-remove:before {
    transform: rotate(45deg);
}
.tags-input-remove:after {
    transform: rotate(-45deg);
}

/* Tag badge styles */
.tags-input-badge {
    display: inline-block;
    margin-top: 5px;
    padding: 10px;
    font-size: 100%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
}

.tags-input-badge-pill {
    padding-right: 0.6em;
    padding-left: 0.6em;
    border-radius: 10rem;
}

.tags-input-badge-selected-default {
    color: #212529;
    background-color: #f0f1f2;
}

/* Typeahead - badges */
.typeahead-badges > span {
    cursor: pointer;
    margin-right: 0.3rem;
}

/* Typeahead - dropdown */
.typeahead-dropdown {
    list-style-type: none;
    padding: 0;
    margin: 0;
    position: absolute;
    width: 100%;
    z-index: 1000;
}

.typeahead-dropdown li {
    padding: .25rem 1rem;
    cursor: pointer;
}

/* Typeahead elements style/theme */
.tags-input-typeahead-item-default {
    color: #fff;
    background-color: #343a40;
}

.tags-input-typeahead-item-highlighted-default {
    color: #fff;
    background-color: #f44336;
}
</style>
